import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { conditionMeta, money, categoryLabel } from "@/lib/constants";
import { ImageOff, MapPin } from "lucide-react";

export default function ListingCard({ listing }) {
  const cond = conditionMeta(listing.condition);
  const sold = listing.status === "sold";
  const img = listing.images?.[0];

  return (
    <Link
      to={`/marketplace/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="group block"
    >
      <Card className="overflow-hidden border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10">
        <div className="relative aspect-square overflow-hidden bg-secondary">
          {img ? (
            <img
              src={img}
              alt={listing.title}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-muted-foreground">
              <ImageOff className="h-10 w-10" />
            </div>
          )}
          {sold && (
            <span
              className="absolute bottom-2 right-2 rounded bg-muted-foreground/90 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-background"
              data-testid={`listing-sold-badge-${listing.id}`}
            >
              Sold
            </span>
          )}
          <Badge
            className="absolute left-2 top-2 border-0 text-[10px] font-semibold text-background"
            style={{ backgroundColor: cond.color }}
          >
            {cond.label}
          </Badge>
        </div>
        <div className="p-3">
          <p className="truncate text-xs text-muted-foreground">
            {listing.brand || categoryLabel(listing.category)}
          </p>
          <h3 className="mt-0.5 truncate font-medium leading-tight">{listing.title}</h3>
          <div className="mt-2 flex items-center justify-between">
            <span className="font-display text-lg font-bold text-primary">
              {money(listing.price, listing.currency)}
            </span>
            {listing.location && (
              <span className="flex items-center gap-1 text-xs text-muted-foreground">
                <MapPin className="h-3 w-3" />
                {listing.location}
              </span>
            )}
          </div>
        </div>
      </Card>
    </Link>
  );
}
